import type { CSSProperties } from 'react';
import type { PosColumnResponsiveProps } from 'pos-client/components/shared/Layout/Grid/PosColumn';

export const fullWidth: CSSProperties = { width: '100%' };

export const defaultColOptions: PosColumnResponsiveProps = {
  span: 24,
  md: 12,
  lg: 8,
};
